/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */

export const Command = Object.freeze({
    Begin:              1,
    Rectangle:          2,
    Ellipse:            3,
    PathMoveTo:         4,
    PathLineTo:         5,
    PathArcTo:          6,
    PathCurveTo:        7,
    PathClose:          8,
    Fill:               9,
    Stroke:            10,
})

export const cmd = (type, ...args) => {
    return {
        type: type,
        args: args
    }
}
